import { render, staticRenderFns } from "./Export.vue?vue&type=template&id=6c07827a&scoped=true&"
import script from "./Export.vue?vue&type=script&lang=js&"
export * from "./Export.vue?vue&type=script&lang=js&"
import style0 from "./Export.vue?vue&type=style&index=0&id=6c07827a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c07827a",
  null
  
)

export default component.exports